<template>
    <transition name="swipe">
        <div v-if="show" class="card">

            <!-- TODO: Load responsive image size-->
            <a :href='roasterUrl'>
            
                <img v-bind:src="coffee.seller.logo_image" class="result-roaster-logo-fig roaster-logo">
            </a>

            <a :href='coffeeUrl'>
                <img v-bind:src="getFlavourImageUrl(coffee)" class="coffee-img" alt="Coffee bags" />
            </a>

            <h4>
                <strong>{{ coffee.name }}</strong>
            </h4>

            <p class="font-xs grey-font">{{ tastingNotes }}</p>

            <h4>
                {{ getRoastLevel(coffee.coffee_roast) }}
            </h4>

            <div v-if="coffee.is_decaf" class="decaf-tag">decaf</div>

            <slot></slot>
        </div>
    </transition>
</template>

<script>
    import CoffeeMixin from '../../mixins/coffee-mixin';

    export default {
        props: {
            coffee: Object,
            show: true,
            disableLink: Boolean
        },
        computed: {
            roasterUrl() {
                if (this.disableLink || !this.coffee) {
                    return null
                }
                return `/workplace/roasters/${this.coffee.seller.id}`;
            },
            coffeeUrl() {
                if (this.disableLink || !this.coffee) {
                    return null
                }
                return `/workplace/coffees/${this.coffee.id}`;
            },
            tastingNotes() {
                if (this.coffee && this.coffee.tasting_notes) {
                    return this.coffee.tasting_notes.join(' | ').toLowerCase();
                }
            },
        },
        mixins: [CoffeeMixin]
    }
</script>

<style lang="scss" scoped>
    @import "./../../styles/variables_workplace";

    .card {
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 1.5rem;
        padding: 20px 20px 10px 20px;
        max-width: 300px;
        min-height: 96%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        border-radius: 15px;
        box-shadow: 6px 6px 8px -4px #999;
        position: relative;
    }

    .card h4 {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 36px;
        margin: 6px 0;
    }

    .roaster-logo {
        margin: auto;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background-color: white;
        border: solid 2px #465f87;
    }

    .coffee-img {
        max-width: 80%;
        height: 224px;
        margin: auto;
        transition: all .4s;
        &:hover {
             transform: scale(1.2);
        }
    }

    .swipe-leave-active {
        transition: opacity 1s ease-in 1s, transform 1.2s ease-in 1s;
    }

    .swipe-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
        transform: translate(0, -500px) scale(0.8);

    }

    .swipe-enter-active {
        transition: transform 1s ease-out;
        /*transition: opacity 3.5s;*/
    }

    .swipe-enter {
        transform: translate(400px, 0px);
        opacity: 0;
    }

    .decaf-tag {
        position: absolute;
        left: -27px;
        top: 42%;
        background-color: $yellow;
        transform: rotate(90deg);
        font-size: 24px;
        font-weight: normal;
        color: $white;
        margin: 0;
        padding: 14px 24px;
        border-radius: 10px 10px 0 0;
        z-index: 2;
    }

    @media only screen and (max-width: 414px) {
        .card {
            width: 300px;
            padding: 8px;
            box-shadow: 2px 2px 4px -2px #999;
        }
        .coffee-img {
            max-width: 70%;
        }
    }
</style>
